import { render, staticRenderFns } from "./NetworkAdd.vue?vue&type=template&id=871ce608&scoped=true"
import script from "./NetworkAdd.vue?vue&type=script&lang=ts"
export * from "./NetworkAdd.vue?vue&type=script&lang=ts"
import style0 from "./NetworkAdd.vue?vue&type=style&index=0&id=871ce608&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871ce608",
  null
  
)

export default component.exports